/**
 * On unless the app's GTM setup turns it off with `initGtm({ ga4Events: false })`,
 * as an app with analytics of its own (skytree) does. Off, no events are sent
 * and no account flows start.
 */
let enabled = true;

/** Called by `initGtm` for a container that must not get share's GA4 events. */
export function disableGa4(): void {
  enabled = false;
}

/** Checked where events and flows start; callers never ask. */
export function isGa4Enabled(): boolean {
  return enabled;
}

/**
 * This site's agent, from its site schema: the `agent_id` of every GA4 event.
 * Ecommerce events fall back to the API's echo until it lands; account-flow
 * events wait for it.
 */
let siteAgentId = '';
let markReady: (agentId: string) => void = () => {};
// Callbacks run in subscription order, so queued events keep their order.
const ready = new Promise<string>(resolve => {
  markReady = resolve;
});

/** Called by the Site store whenever a schema lands. */
export function setGa4SiteAgentId(agentId: string | undefined): void {
  if (!agentId) return;
  siteAgentId = agentId;
  markReady(agentId);
}

export function getGa4SiteAgentId(): string {
  return siteAgentId;
}

/** Resolves with the agent id once the first schema lands. */
export function whenGa4SiteAgentId(): Promise<string> {
  return ready;
}
